import * as yup from 'yup';
import { validateEmail } from 'src/validations';
import { VALIDATION_MESSAGE } from 'src/formMapper';

export const validationSchema = yup
  .object()
  .shape({
    full_name: yup.string().required(VALIDATION_MESSAGE.fullName),
    email: validateEmail
  })
  .defined();
